export const ieArrayFromObject = obj => {
  const arr = [];
  Object.keys(obj).forEach(value => arr.push(obj[value]));

  return arr;
};
